import { Instance } from 'mobx-state-tree';
import * as React from 'react';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { Page, TLCode } from '../../common/enums';
import { ColDef } from 'ag-grid-community';
import { observer } from 'mobx-react';
import BaseGridXL from '../common/grid/BaseGridXL';
import styled from '@emotion/styled';
import { IconNames } from '@blueprintjs/icons';
import { Button, Tooltip, Label } from '@blueprintjs/core';
import { Position } from '@blueprintjs/core/lib/esm/common/position';
import { Form } from 'react-final-form';
import { PharmacyAnnualReviewSearchCriteria } from '../../store/PharmacyAnnualReviewStore';
import { Pharmacy } from '../../store/models/Pharmacy';

interface MissingBlackPointManagerProps extends WithTranslateProps {
  missingBlackPoint: any[];
  searchCriteria: Instance<typeof PharmacyAnnualReviewSearchCriteria>;
  onSearch: (criteria: any) => void;
  onChangeCriteria: (direction: number) => void;
  pharmacyList: Array<Instance<typeof Pharmacy>>;
  navigate: (url: string) => void;
}

interface MissingBlackPointManagerState {}

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const ContainerSearchForm = styled.div`
  display: flex;
  flex: 0;
  flex-direction: row;
  .bp3-form-content {
    margin-right: 5px;
  },
`;

const ContainerGrid = styled.div`
  display: flex;
  flex-direction: row;
  width: 400px;
  flex: 1;
`;

const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const DivColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 25%;
  height: 600px;
  justify-content: space-between;
`;

@observer
class MissingBlackPointManager extends React.Component<MissingBlackPointManagerProps, MissingBlackPointManagerState> {
  state = {
    searchCriteria: this.props.searchCriteria,
    missingBlackPoint: [],
  } as MissingBlackPointManagerState;

  columns = [
    {
      headerName: this.props.translate(TLCode.PHARMACY_Level),
      field: 'level',
      width: 35,
      suppressMenu: true,
    },
    {
      headerName: this.props.translate(TLCode.PHARMACY_ApbNr),
      field: 'apbNumber',
      width: 80,
    },
    {
      headerName: this.props.translate(TLCode.PHARMACY),
      field: 'pharmacyName',
      // width: 350,
    },
    {
      headerName: this.props.translate(TLCode.MISSING_BLACKPOINTS_NumberBP),
      field: 'blackPointDays',
      width: 70,
    },
  ] as ColDef[];

  buildGridData = () => {
    return this.props.missingBlackPoint
      .filter((mbp) => this.props.pharmacyList.find((p) => p.pharmacyId === mbp.pharmacyId) !== undefined)
      .map((mbp) => ({
        ...mbp,
        apbNumber: mbp.apbNumber,
        pharmacyName: mbp.name,
        level: mbp.level,
      }));
  };

  buildFilteredGridData = (list) => {
    return list
      .filter((mbp) => this.props.pharmacyList.find((p) => p.pharmacyId === mbp.pharmacyId) !== undefined)
      .map((ss) => ({
        ...ss,
        apbNumber: ss.apbNumber,
        pharmacyName: ss.name,
        level: ss.level,
      }));
  };

  onRowDoubleClicked = (ev) => {
    this.props.navigate(`${Page.PharmacyPage}/${ev.data.pharmacyId}`);
  };

  handleChangeValue = (value) => {
    // this.setState({ searchCriteria: value });
  };

  render() {
    const { pharmacyList, translate } = this.props;
    return (
      <Container>
        <Form onSubmit={this.props.onSearch} initialValues={{ filter: this.props.searchCriteria }}>
          {({ handleSubmit }) => (
            <ContainerSearchForm>
              <Tooltip
                content={translate(TLCode.MULTI_CALENDAR_TOOLBOX_PreviousYear)}
                position={Position.BOTTOM}
                hoverOpenDelay={750}
              >
                <Button
                  icon={IconNames.CHEVRON_LEFT}
                  large={true}
                  style={{ height: '30px', marginLeft: '5px' }}
                  onClick={() => this.props.onChangeCriteria(-1)}
                />
              </Tooltip>
              <Label
                style={{
                  justifyContent: 'center',
                  fontWeight: 'bold',
                  fontSize: '25px',
                  verticalAlign: 'center',
                }}
              >
                {this.props.searchCriteria.year}
              </Label>
              <Tooltip
                content={translate(TLCode.MULTI_CALENDAR_TOOLBOX_NextYear)}
                position={Position.BOTTOM}
                hoverOpenDelay={750}
              >
                <Button
                  icon={IconNames.CHEVRON_RIGHT}
                  large={true}
                  style={{ height: '30px', marginLeft: '5px' }}
                  onClick={() => this.props.onChangeCriteria(1)}
                />
              </Tooltip>
            </ContainerSearchForm>
          )}
        </Form>
        {this.props.missingBlackPoint && (
          <Container>
            <DivLine>
              <DivColumn>
                {translate(TLCode.MISSING_BLACKPOINTS_FilterAll)}
                <BaseGridXL
                  columnDefs={this.columns}
                  rowData={this.buildGridData()}
                  keyName={'pharmacyId'}
                  onRowDoubleClicked={this.onRowDoubleClicked}
                  suppressClickEdit={true}
                />
              </DivColumn>
              <DivColumn>
                {translate(TLCode.MISSING_BLACKPOINTS_FilterComplete)}
                <BaseGridXL
                  columnDefs={this.columns}
                  rowData={this.buildFilteredGridData(
                    this.props.missingBlackPoint.filter((ph) => ph.blackPointDays === 42),
                  )}
                  keyName={'pharmacyId'}
                  onRowDoubleClicked={this.onRowDoubleClicked}
                  suppressClickEdit={true}
                />
              </DivColumn>
              <DivColumn>
                {translate(TLCode.MISSING_BLACKPOINTS_FilterPartial)}
                <BaseGridXL
                  columnDefs={this.columns}
                  rowData={this.buildFilteredGridData(
                    this.props.missingBlackPoint.filter((ph) => ph.blackPointDays > 0 && ph.blackPointDays < 42),
                  )}
                  keyName={'pharmacyId'}
                  onRowDoubleClicked={this.onRowDoubleClicked}
                  suppressClickEdit={true}
                />
              </DivColumn>
              <DivColumn>
                {translate(TLCode.MISSING_BLACKPOINTS_FilterEmpty)}
                <BaseGridXL
                  columnDefs={this.columns}
                  rowData={this.buildFilteredGridData(
                    this.props.missingBlackPoint.filter((ph) => ph.blackPointDays === 0),
                  )}
                  keyName={'pharmacyId'}
                  onRowDoubleClicked={this.onRowDoubleClicked}
                  suppressClickEdit={true}
                />
              </DivColumn>
            </DivLine>
          </Container>
        )}
      </Container>
    );
  }
}

export default withTranslate(MissingBlackPointManager);
